export default __webpack_public_path__ + "dist/media/SavingTimeBg.2e8df05e.png";